__turbopack_context__.v({
  "action": "index-module-scss-module__5Z5fPq__action",
  "ant-dropdown-menu": "index-module-scss-module__5Z5fPq__ant-dropdown-menu",
  "ant-dropdown-menu-item": "index-module-scss-module__5Z5fPq__ant-dropdown-menu-item",
  "ant-dropdown-menu-item-selected": "index-module-scss-module__5Z5fPq__ant-dropdown-menu-item-selected",
  "ant-dropdown-menu-title-content": "index-module-scss-module__5Z5fPq__ant-dropdown-menu-title-content",
  "back-top-wrap": "index-module-scss-module__5Z5fPq__back-top-wrap",
  "contentTable": "index-module-scss-module__5Z5fPq__contentTable",
  "filterTableSelect": "index-module-scss-module__5Z5fPq__filterTableSelect",
  "header": "index-module-scss-module__5Z5fPq__header",
  "nopermission": "index-module-scss-module__5Z5fPq__nopermission",
  "subscribe": "index-module-scss-module__5Z5fPq__subscribe",
  "table": "index-module-scss-module__5Z5fPq__table",
  "years": "index-module-scss-module__5Z5fPq__years",
});
